import { CssProp, Styles, Theme } from '@core/utils/css';
import { ClassNames, css } from '@emotion/react';

import React, { memo, PropsWithChildren, RefObject } from 'react';
import { FormContainer, FormContainerProps } from '../form';
import { DialogContent } from '@mui/material';

const styles = {
  container: css`
    line-height: 1.5;
    position: relative;

    background-color: ${Theme.isDark ? Theme.modalBackgroundColor : '#FFF'};
    color: ${Theme.isDark ? Theme.modalTextColor : '#20455e'};

    padding-top: 20px !important;
  `,

  fullHeight: css`
    height: 60vh;
  `,

  noPadding: css`
    padding: 0;
  `,

  tabContent: css`
    padding: 0;
  `,

  tabContentFullHeight: css`
    overflow: hidden;

    > div,
    form {
      ${Styles.absoluteFill};
    }
  `,
};

export interface ModalContentProps {
  customCss?: CssProp;
  fullHeight?: boolean;
  noPadding?: boolean;
  tabContent?: boolean;
  formContainer?: FormContainerProps;
  containerRef?: RefObject<HTMLElement>;
  id?: string;
}

export const ModalContent = memo((props: PropsWithChildren<ModalContentProps>) => {
  let children = props.children;

  if (props.formContainer) {
    children = <FormContainer {...props.formContainer}>{children}</FormContainer>;
  }

  return (
    <ClassNames>
      {({ css }) => (
        <DialogContent
          id={props.id}
          classes={{
            root: css(
              styles.container,
              props.fullHeight && styles.fullHeight,
              props.noPadding && styles.noPadding,
              props.tabContent && styles.tabContent,
              props.tabContent && props.fullHeight && styles.tabContentFullHeight,
              props.customCss,
            ),
          }}
        >
          {children}
        </DialogContent>
      )}
    </ClassNames>
  );
});
